<template>
  <div>
    <div class="text-left">
      <v-app-bar-nav-icon @click.stop="toggleMiniDisplay()" class="ml-3 mt-3" />
      <v-img src="@/assets/logo.png" :contain="true" width="100" class="mx-auto mt-3" />
    </div>
    <v-divider class="my-2" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'TheSidebarHeader',
  methods: {
    toggleMiniDisplay(): void {
      this.$emit('toggle');
    }
  }
});
</script>
